import {useMutation} from "@tanstack/react-query";
import {toast} from "sonner";

import {TOAST_CONFIG} from "@/lib/constansts";
import {useInvalidate} from "@/src/modules/core/hooks";
import {captureParkingSubmitError} from "@/src/modules/core/lib/glitchtip/parking-capture";

import {darsService} from "../services";

export default function useDarUpdate(darId?: number | null) {
  const invalidateDar = useInvalidate("dar");
  const invalidateDars = useInvalidate("dars");

  return useMutation({
    mutationFn: (data: Record<string, unknown>) =>
      darsService.updateDar(darId!, data),
    onSuccess: () => {
      invalidateDar();
      invalidateDars();
      toast.success("DAR updated successfully", TOAST_CONFIG);
    },
    onError: (error) => {
      captureParkingSubmitError(error, {feature: "dars", operation: "dar_update"});
    },
  });
}
